import { ApiRequestStatusEnum } from '../enums/common/api';
import { AuthorizationErrorMessageEnum, AuthorizationSuccessMessageEnum, getAuthorizationErrorMessage } from '../enums/authorization/message';
import { getProductErrorMessage, ProductErrorMessageEnum, ProductSuccessMessageEnum } from '../enums/product/message';
import { getInventoryErrorMessage, InventoryErrorMessageEnum, InventorySuccessMessageEnum } from '../enums/inventory/message';
import { getPodErrorMessage, PodErrorMessageEnum, PodSuccessMessageEnum } from '../enums/pod/message';
import { getPriceErrorMessage, PriceErrorMessageEnum, PriceSuccessMessageEnum } from '../enums/price/message';
import { CommunicationErrorMessageEnum, CommunicationSuccessMessageEnum, getCommunicationErrorMessage } from '../enums/communication/message';
import { getStoreErrorMessage, StoreErrorMessageEnum, StoreSuccessMessageEnum } from '../enums/store/message';
import { CouponStatusEnum } from '../enums/price/coupon';
import { CustomerErrorMessageEnum, CustomerSuccessMessageEnum, getCustomerErrorMessage } from '../enums/customer/message';
import { FoodPartnerErrorMessageEnum, FoodPartnerSuccessMessageEnum, getFoodPartnerErrorMessage } from '../enums/food_partner/message';
import { BenefitErrorMessageEnum, BenefitSuccessMessageEnum, getBenefitErrorMessage } from '../enums/benefit/message';
import { getReservationErrorMessage, ReservationErrorMessageEnum, ReservationSuccessMessageEnum } from '../enums/reservation/message';
import { PromotionCampaignStatusEnum } from '../enums/price/promotion_campaign';
import { getOrderErrorMessage, OrderErrorMessageEnum, OrderSuccessMessageEnum } from '../enums/order/message';
import { getPopErrorMessage, PopErrorMessageEnum } from '../enums/pop/message';

//---------------------------------------------------------------------------------------------------------------------- Authorization

export const getTokenNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: AuthorizationSuccessMessageEnum.SIGN_IN
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getAuthorizationErrorMessage(response?.payload?.message, AuthorizationErrorMessageEnum.SIGN_IN)
        };
};

export const deleteTokenNotificationData = () => {
    return {
        status: ApiRequestStatusEnum.FULFILLED,
        message: AuthorizationSuccessMessageEnum.SIGN_OUT
    };
};

//---------------------------------------------------------------------------------------------------------------------- Communication


export const getNotificationsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCommunicationErrorMessage(response?.payload?.message, CommunicationErrorMessageEnum.GET_NOTIFICATIONS)
    };
};


export const createNotificationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: CommunicationSuccessMessageEnum.CREATE_NOTIFICATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getCommunicationErrorMessage(response?.payload?.message, CommunicationErrorMessageEnum.CREATE_NOTIFICATION)
        };
};

export const getNotificationTypesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCommunicationErrorMessage(response?.payload?.message, CommunicationErrorMessageEnum.GET_NOTIFICATION_TYPES)
    };
};

export const deleteNotificationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: CommunicationSuccessMessageEnum.DELETE_NOTIFICATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getCommunicationErrorMessage(response?.payload?.message, CommunicationErrorMessageEnum.DELETE_NOTIFICATION)
        };
};

export const getDeliveryNotificationsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCommunicationErrorMessage(response?.payload?.message, CommunicationErrorMessageEnum.GET_DELIVERY_NOTIFICATIONS)
    };
};

export const getDeliveryNotificationNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCommunicationErrorMessage(response?.payload?.message, CommunicationErrorMessageEnum.GET_DELIVERY_NOTIFICATION)
    };
};

export const deleteDeliveryNotificationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: CommunicationSuccessMessageEnum.DELETE_DELIVERY_NOTIFICATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getCommunicationErrorMessage(response?.payload?.message, CommunicationErrorMessageEnum.DELETE_DELIVERY_NOTIFICATION)
        };
};

export const createDeliveryNotificationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: CommunicationSuccessMessageEnum.CREATE_DELIVERY_NOTIFICATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getCommunicationErrorMessage(response?.payload?.message, CommunicationErrorMessageEnum.CREATE_DELIVERY_NOTIFICATION)
        };
};

export const updateDeliveryNotificationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: CommunicationSuccessMessageEnum.UPDATE_DELIVERY_NOTIFICATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getCommunicationErrorMessage(response?.payload?.message, CommunicationErrorMessageEnum.UPDATE_DELIVERY_NOTIFICATION)
        };
};

//---------------------------------------------------------------------------------------------------------------------- Customer

export const getCustomersByPhoneNumberNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.GET_CUSTOMERS_BY_PHONE_NUMBER)
    };
};

export const getCustomersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.GET_CUSTOMERS)
    };
};

export const getCustomerNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.GET_CUSTOMER)
    };
};

export const getCustomersByIdsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.GET_CUSTOMERS_BY_IDS)
    };
};

export const getCustomerActivitiesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.GET_CUSTOMERS_ACTIVITIES)
    };
};

export const getIncorrectEmailsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.GET_INCORRECT_EMAILS)
    };
};

export const createIncorrectEmailNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: CustomerSuccessMessageEnum.CREATE_INCORRECT_EMAIL
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.CREATE_INCORRECT_EMAIL)
        };
};

export const createIncorrectEmailSmsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: CustomerSuccessMessageEnum.CREATE_INCORRECT_EMAIL_SMS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.CREATE_INCORRECT_EMAIL_SMS)
        };
};

export const getCustomerBlockadeHistoryRegistriesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.GET_CUSTOMER_BLOCKADE_HISTORY_REGISTRIES)
    };
};

export const getCustomerBlockadeRegistriesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.GET_CUSTOMER_BLOCKADE_REGISTRIES)
    };
};

export const deleteCustomerBlockadeRegistryNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: CustomerSuccessMessageEnum.DELETE_CUSTOMER_BLOCKADE_REGISTRY
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.DELETE_CUSTOMER_BLOCKADE_REGISTRY)
        };
};

export const createCustomerBlockadeRegistryNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: CustomerSuccessMessageEnum.CREATE_CUSTOMER_BLOCKADE_REGISTRY
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getCustomerErrorMessage(response?.payload?.message, CustomerErrorMessageEnum.CREATE_CUSTOMER_BLOCKADE_REGISTRY)
        };
};

//---------------------------------------------------------------------------------------------------------------------- Inventory

export const getProductBatchesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_PRODUCT_BATCHES)
    };
};

export const getInvoiceNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_INVOICE)
    };
};

export const updateProductsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: InventorySuccessMessageEnum.UPDATE_PRODUCTS_DEFINITION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.UPDATE_PRODUCTS_DEFINITION)
        };
};

export const getInventoryExportNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: InventorySuccessMessageEnum.GET_INVENTORY_EXPORT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_INVENTORY_EXPORT)
        };
};

export const getCounterpartiesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_COUNTERPARTIES)
    };
};

export const getAllInventoryProductsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_ALL_PRODUCTS)
    };
};

export const getWarehouseProductBatchesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_WAREHOUSE_PRODUCT_BATCHES)
    };
};

export const getWarehouseDocumentsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_WAREHOUSE_DOCUMENTS)
    };
};

export const getWarehouseDocumentNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_WAREHOUSE_DOCUMENT)
    };
};

export const createWarehouseDocumentNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? response?.payload === 'generateLabelsFailed'
            ? {
                status: ApiRequestStatusEnum.FULFILLED,
                message: InventorySuccessMessageEnum.PARTIALLY_CREATE_WAREHOUSE_DOCUMENT
            }
            : {
                status: ApiRequestStatusEnum.FULFILLED,
                message: InventorySuccessMessageEnum.CREATE_WAREHOUSE_DOCUMENT
            }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.CREATE_WAREHOUSE_DOCUMENT)
        };
};

export const generateFoodPartnerOrderDocumentsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
                status: ApiRequestStatusEnum.FULFILLED,
                message: InventorySuccessMessageEnum.CREATE_WAREHOUSE_DOCUMENT_REQUEST
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.CREATE_WAREHOUSE_DOCUMENT)
        };
};


export const generateReservationDocumentsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GENERATE_RESERVATION_DOCUMENTS)
    };
};


export const generateWarehouseDocumentLabelsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: InventorySuccessMessageEnum.GENERATE_WAREHOUSE_DOCUMENT_LABELS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GENERATE_WAREHOUSE_DOCUMENT_LABELS)
        };
};


export const getGenerateWarehouseDocumentRequestsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_GENERATE_WAREHOUSE_DOCUMENT_REQUESTS)
    };
};

export const getAllWarehousesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_ALL_WAREHOUSES)
    };
};

export const getWarehouseStockSummariesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_WAREHOUSE_STOCK_SUMMARIES)
    };
};

export const getWarehouseStockNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_WAREHOUSE_STOCK)
    };
};

export const getProductStockNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_PRODUCT_STOCK)
    };
};

export const getFoodPartnerOrdersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_FOOD_PARTNER_ORDERS)
    };
};

export const getFoodPartnerOrderNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_FOOD_PARTNER_ORDER)
    };
};

export const sendFoodPartnerOrderNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: InventorySuccessMessageEnum.SEND_FOOD_PARTNER_ORDER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.SEND_FOOD_PARTNER_ORDER)
        };
};

export const generateFoodPartnerOrderLabelsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: InventorySuccessMessageEnum.GENERATE_FOOD_PARTNER_ORDER_LABELS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GENERATE_FOOD_PARTNER_ORDER_LABELS)
        };
};

export const updateFoodPartnerOrderStatusNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: InventorySuccessMessageEnum.UPDATE_FOOD_PARTNER_ORDER_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.UPDATE_FOOD_PARTNER_ORDER_STATUS)
        };
};

export const createFoodPartnerOrderNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? response?.payload === 'generateLabelsFailed'
            ? {
                status: ApiRequestStatusEnum.FULFILLED,
                message: InventorySuccessMessageEnum.PARTIALLY_CREATE_FOOD_PARTNER_ORDER
            }
            : {
                status: ApiRequestStatusEnum.FULFILLED,
                message: InventorySuccessMessageEnum.CREATE_FOOD_PARTNER_ORDER
            }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.CREATE_FOOD_PARTNER_ORDER)
        };
};

export const updateFoodPartnerOrderNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? response?.payload === 'generateLabelsFailed'
            ? {
                status: ApiRequestStatusEnum.FULFILLED,
                message: InventorySuccessMessageEnum.PARTIALLY_UPDATE_FOOD_PARTNER_ORDER
            }
            : {
                status: ApiRequestStatusEnum.FULFILLED,
                message: InventorySuccessMessageEnum.UPDATE_FOOD_PARTNER_ORDER
            }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.UPDATE_FOOD_PARTNER_ORDER)
        };
};

export const getFoodPartnerOrderHistoryNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_FOOD_PARTNER_ORDER_HISTORY)
    };
};

export const getFoodPartnerOrderAttachmentNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.GET_FOOD_PARTNER_ORDER_ATTACHMENT)
    };
};

export const confirmDeliveryDocumentNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: InventorySuccessMessageEnum.CONFIRM_DELIVERY_DOCUMENT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.CONFIRM_DELIVERY_DOCUMENT)
        };
};

export const updateAndConfirmDeliveryDocumentNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: InventorySuccessMessageEnum.UPDATE_AND_CONFIRM_DELIVERY_DOCUMENT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getInventoryErrorMessage(response?.payload?.message, InventoryErrorMessageEnum.UPDATE_AND_CONFIRM_DELIVERY_DOCUMENT)
        };
};

//---------------------------------------------------------------------------------------------------------------------- Pod

export const getDevicesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.GET_DEVICES)
    };
};

export const getPodNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.GET_POD)
    };
};

export const getPodsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.GET_PODS)
    };
};

export const getAdvertisementsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.GET_ADVERTISEMENTS)
    };
};

export const createAdvertisementsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.CREATE_ADVERTISEMENTS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.CREATE_ADVERTISEMENTS)
        };
};

export const updateAdvertisementsDisplayOrderNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.UPDATE_ADVERTISEMENTS_DISPLAY_ORDER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.UPDATE_ADVERTISEMENTS_DISPLAY_ORDER)
        };
};

export const updateAdvertisementDisplayTimeNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.UPDATE_ADVERTISEMENT_DISPLAY_TIME
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.UPDATE_ADVERTISEMENT_DISPLAY_TIME)
        };
};

export const updateAdvertisementProductsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.UPDATE_ADVERTISEMENT_DISPLAY_TIME
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.UPDATE_ADVERTISEMENT_DISPLAY_TIME)
        };
};

export const deleteAdvertisementNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.DELETE_ADVERTISEMENT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.DELETE_ADVERTISEMENT)
        };
};

export const getAllIndoorPartnersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.GET_ALL_INDOOR_PARTNERS)
    };
};

export const getIndoorPartnersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.GET_INDOOR_PARTNERS)
    };
};

export const getIndoorPartnerNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.GET_INDOOR_PARTNER)
    };
};

export const deleteIndoorPartnerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.DELETE_INDOOR_PARTNER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.DELETE_INDOOR_PARTNER)
        };
};

export const createIndoorPartnerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.CREATE_INDOOR_PARTNER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.CREATE_INDOOR_PARTNER)
        };
};

export const updateIndoorPartnerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.UPDATE_INDOOR_PARTNER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.UPDATE_INDOOR_PARTNER)
        };
};

export const createPodNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.CREATE_POD
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.CREATE_POD)
        };
};

export const updatePodNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.UPDATE_POD
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.UPDATE_POD)
        };
};

//---------------------------------------------------------------------------------------------------------------------- Pop

export const getPopNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPopErrorMessage(response?.payload?.message, PopErrorMessageEnum.GET_POP)
    };
};

export const getPopsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPopErrorMessage(response?.payload?.message, PopErrorMessageEnum.GET_POP)
    };
};

export const getHubNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPopErrorMessage(response?.payload?.message, PopErrorMessageEnum.GET_HUB)
    };
};

export const getHubsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPopErrorMessage(response?.payload?.message, PopErrorMessageEnum.GET_HUBS)
    };
};

export const getEventRegistersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.GET_EVENT_REGISTERS)
    };
};

export const deleteEventRegisterNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.DELETE_EVENT_REGISTER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.DELETE_EVENT_REGISTER)
        };
};

export const createEventRegisterNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PodSuccessMessageEnum.CREATE_EVENT_REGISTER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPodErrorMessage(response?.payload?.message, PodErrorMessageEnum.CREATE_EVENT_REGISTER)
        };
};

//---------------------------------------------------------------------------------------------------------------------- Store

export const getBusinessDataNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getStoreErrorMessage(response?.payload?.message, StoreErrorMessageEnum.GET_BUSINESS_DATA)
    };
};

export const getSuppliersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getStoreErrorMessage(response?.payload?.message, StoreErrorMessageEnum.GET_SUPPLIERS)
    };
};

export const getSupplierNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getStoreErrorMessage(response?.payload?.message, StoreErrorMessageEnum.GET_SUPPLIER)
    };
};

export const updateSupplierStatusNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: StoreSuccessMessageEnum.UPDATE_SUPPLIER_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getStoreErrorMessage(response?.payload?.message, StoreErrorMessageEnum.UPDATE_SUPPLIER_STATUS)
        };
};

export const getSupplierKeyNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getStoreErrorMessage(response?.payload?.message, StoreErrorMessageEnum.GET_SUPPLIER_KEY)
    };
};

export const getNewSupplierKeyNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getStoreErrorMessage(response?.payload?.message, StoreErrorMessageEnum.GET_NEW_SUPPLIER_KEY)
    };
};

export const createSupplierNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: StoreSuccessMessageEnum.CREATE_SUPPLIER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getStoreErrorMessage(response?.payload?.message, StoreErrorMessageEnum.CREATE_SUPPLIER)
        };
};

export const updateSupplierNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: StoreSuccessMessageEnum.UPDATE_SUPPLIER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getStoreErrorMessage(response?.payload?.message, StoreErrorMessageEnum.UPDATE_SUPPLIER)
        };
};

//---------------------------------------------------------------------------------------------------------------------- Price

export const getProductPromotionsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PROMOTION)
    };
};

export const deleteProductPromotionsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.DELETE_PROMOTION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.DELETE_PROMOTION)
        };
};

export const getProductExpirationPromotionsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PROMOTION)
    };
};

export const deleteProductExpirationPromotionsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.DELETE_PROMOTION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.DELETE_PROMOTION)
        };
};

export const getPromotionNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PROMOTION)
    };
};

export const updatePromotionNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_PROMOTION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_PROMOTION)
        };
};

export const deletePromotionNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.DELETE_PROMOTION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.DELETE_PROMOTION)
        };
};

export const getPriceNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PRICE)
    };
};

export const updatePricesNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_PRICES
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_PRICES)
        };
};

export const getCouponNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_COUPON)
    };
};

export const getCouponsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_COUPONS)
    };
};

export const getCouponQRCodeNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_COUPON_QR_CODE)
    };
};

export const updateCouponStatusNotificationData = (response, couponStatus) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: couponStatus === CouponStatusEnum.DELETED
                ? PriceSuccessMessageEnum.DELETE_COUPON
                : PriceSuccessMessageEnum.UPDATE_COUPON_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, couponStatus === CouponStatusEnum.DELETED
                ? PriceErrorMessageEnum.DELETE_COUPON
                : PriceErrorMessageEnum.UPDATE_COUPON_STATUS)
        };
};

export const getCouponTranslationNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_COUPON_TRANSLATION)
    };
};

export const createCouponNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.CREATE_COUPON
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.CREATE_COUPON)
        };
};

export const updateCouponNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_COUPON
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_COUPON)
        };
};

export const updateCouponTranslationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_COUPON_TRANSLATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_COUPON_TRANSLATION)
        };
};

export const getAutomaticCouponSettingsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_AUTOMATIC_COUPON_SETTINGS)
    };
};

export const getAutomaticCouponSettingNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_AUTOMATIC_COUPON_SETTING)
    };
};

export const updateAutomaticCouponSettingNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_AUTOMATIC_COUPON_SETTING
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_AUTOMATIC_COUPON_SETTING)
        };
};

export const updateAutomaticCouponSettingStatusNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_AUTOMATIC_COUPON_SETTING_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_AUTOMATIC_COUPON_SETTING_STATUS)
        };
};

export const getAutomaticCouponSettingTranslationNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_AUTOMATIC_COUPON_SETTING_TRANSLATION)
    };
};

export const updateAutomaticCouponSettingTranslationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_AUTOMATIC_COUPON_SETTING_TRANSLATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_AUTOMATIC_COUPON_SETTING_TRANSLATION)
        };
};

export const getExpirationPromotionSettingNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_EXPIRATION_PROMOTION_SETTING)
    };
};

export const getAutomaticExpirationPromotionSettingsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_AUTOMATIC_EXPIRATION_PROMOTION_SETTINGS)
    };
};

export const getAutomaticExpirationPromotionSettingNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_AUTOMATIC_EXPIRATION_PROMOTION_SETTING)
    };
};

export const updateExpirationPromotionSettingNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_EXPIRATION_PROMOTION_SETTING
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_EXPIRATION_PROMOTION_SETTING)
        };
};

export const updateAutomaticExpirationPromotionSettingStatusActionNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_AUTOMATIC_EXPIRATION_PROMOTION_SETTING_STATE
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_AUTOMATIC_EXPIRATION_PROMOTION_SETTING_STATE)
        };
};

export const updateAutomaticExpirationPromotionSettingNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_AUTOMATIC_EXPIRATION_PROMOTION_SETTING
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_AUTOMATIC_EXPIRATION_PROMOTION_SETTING)
        };
};

export const getPromotionCampaignNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PROMOTION_CAMPAIGN)
    };
};

export const getPromotionCampaignsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PROMOTION_CAMPAIGNS)
    };
};

export const updatePromotionCampaignStatusNotificationData = (response, couponStatus) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: couponStatus === PromotionCampaignStatusEnum.DELETED
                ? PriceSuccessMessageEnum.DELETE_PROMOTION_CAMPAIGN
                : PriceSuccessMessageEnum.UPDATE_PROMOTION_CAMPAIGN_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, couponStatus === PromotionCampaignStatusEnum.DELETED
                ? PriceErrorMessageEnum.DELETE_PROMOTION_CAMPAIGN
                : PriceErrorMessageEnum.UPDATE_PROMOTION_CAMPAIGN_STATUS)
        };
};

export const createPromotionCampaignNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.CREATE_PROMOTION_CAMPAIGN
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.CREATE_PROMOTION_CAMPAIGN)
        };
};

export const updatePromotionCampaignNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_PROMOTION_CAMPAIGN
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_PROMOTION_CAMPAIGN)
        };
};

export const getPromotionCampaignNotificationNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PROMOTION_CAMPAIGN_NOTIFICATION)
    };
};

export const updatePromotionCampaignNotificationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_PROMOTION_CAMPAIGN_NOTIFICATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_PROMOTION_CAMPAIGN_NOTIFICATION)
        };
};

export const deletePromotionCampaignNotificationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.DELETE_PROMOTION_CAMPAIGN_NOTIFICATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.DELETE_PROMOTION_CAMPAIGN_NOTIFICATION)
        };
};

export const getPromotionCampaignAdvertisementNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PROMOTION_CAMPAIGN_NOTIFICATION)
    };
};

export const updatePromotionCampaignAdvertisementNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_PROMOTION_CAMPAIGN_ADVERTISEMENT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_PROMOTION_CAMPAIGN_ADVERTISEMENT)
        };
};

export const deletePromotionCampaignAdvertisementNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.DELETE_PROMOTION_CAMPAIGN_ADVERTISEMENT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.DELETE_PROMOTION_CAMPAIGN_ADVERTISEMENT)
        };
};

export const getPriceByDateNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PRICE_BY_DATE)
    };
};

export const getStorePromotionSettingsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_STORE_PROMOTION_SETTINGS)
    };
};

export const getStorePromotionSettingNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_STORE_PROMOTION_SETTING)
    };
};

export const updateStorePromotionSettingStatusNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_STORE_PROMOTION_SETTING_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_STORE_PROMOTION_SETTING_STATUS)
        };
};

export const updateStorePromotionSettingNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_STORE_PROMOTION_SETTING
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_STORE_PROMOTION_SETTING)
        };
};

export const getStoreDiscountTypesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_DISCOUNT_TYPES)
    };
};

export const getPriceListsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PRICE_LISTS)
    };
};

export const getAllPriceListsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_ALL_PRICE_LISTS)
    };
};

export const getPodPriceListNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_POD_PRICE_LISTS)
    };
};

export const getPriceListNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.GET_PRICE_LIST)
    };
};

export const createPriceListNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.CREATE_PRICE_LIST
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.CREATE_PRICE_LIST)
        };
};

export const updatePriceListNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_PRICE_LIST
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_PRICE_LIST)
        };
};

export const updatePodPriceListNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.UPDATE_POD_PRICE_LIST
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.UPDATE_POD_PRICE_LIST)
        };
};

export const deletePriceListNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.DELETE_PRICE_LIST
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.DELETE_PRICE_LIST)
        };
};

export const deletePodPriceListNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.DELETE_POD_PRICE_LIST
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.DELETE_POD_PRICE_LIST)
        };
};

export const deleteItemPriceListNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.DELETE_ITEM_PRICE_LIST
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.DELETE_ITEM_PRICE_LIST)
        };
};

export const createItemPriceListNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: PriceSuccessMessageEnum.CREATE_ITEM_PRICE_LIST
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getPriceErrorMessage(response?.payload?.message, PriceErrorMessageEnum.CREATE_ITEM_PRICE_LIST)
        };
};

//---------------------------------------------------------------------------------------------------------------------- Food Partner

export const getFoodPartnersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.GET_FOOD_PARTNERS)
    };
};

export const getAllFoodPartnersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.GET_ALL_FOOD_PARTNERS)
    };
};

export const getFoodPartnerNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.GET_FOOD_PARTNER)
    };
};

export const getFoodPartnersForReservationNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.GET_FOOD_PARTNERS_FOR_RESERVATION)
    };
};

export const createFoodPartnerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: FoodPartnerSuccessMessageEnum.CREATE_FOOD_PARTNER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.CREATE_FOOD_PARTNER)
        };
};

export const updateFoodPartnerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: FoodPartnerSuccessMessageEnum.UPDATE_FOOD_PARTNER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.UPDATE_FOOD_PARTNER)
        };
};

export const deleteFoodPartnerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: FoodPartnerSuccessMessageEnum.DELETE_FOOD_PARTNER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.DELETE_FOOD_PARTNER)
        };
};

export const getContactPersonsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.GET_CONTACT_PERSONS)
    };
};

export const getContactPersonNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.GET_CONTACT_PERSON)
    };
};

export const createContactPersonNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: FoodPartnerSuccessMessageEnum.CREATE_CONTACT_PERSON
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.CREATE_CONTACT_PERSON)
        };
};

export const updateContactPersonNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: FoodPartnerSuccessMessageEnum.UPDATE_CONTACT_PERSON
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.UPDATE_CONTACT_PERSON)
        };
};

export const deleteContactPersonNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: FoodPartnerSuccessMessageEnum.DELETE_CONTACT_PERSON
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.DELETE_CONTACT_PERSON)
        };
};

export const getDocumentsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.GET_DOCUMENTS)
    };
};

export const createDocumentNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: FoodPartnerSuccessMessageEnum.CREATE_DOCUMENT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.CREATE_DOCUMENT)
        };
};

export const deleteDocumentNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: FoodPartnerSuccessMessageEnum.DELETE_DOCUMENT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getFoodPartnerErrorMessage(response?.payload?.message, FoodPartnerErrorMessageEnum.DELETE_DOCUMENT)
        };
};

//---------------------------------------------------------------------------------------------------------------------- Product

export const getProductsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRODUCTS)
    };
};

export const getAllProductProductsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_ALL_PRODUCTS)
    };
};

export const getProductNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRODUCT)
    };
};

export const getProductTranslationsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRODUCT_DETAILS)
    };
};

export const getProductSalesDetailsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRODUCT_SALES_DATA)
    };
};

export const getProductsForReservationNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRODUCTS_FOR_RESERVATION)
    };
};

export const getProductsForPromotionNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRODUCTS_FOR_PROMOTION)
    };
};

export const createProductNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ProductSuccessMessageEnum.CREATE_PRODUCT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.CREATE_PRODUCT)
        };
};

export const updateProductNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ProductSuccessMessageEnum.UPDATE_PRODUCT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.UPDATE_PRODUCT)
        };
};

export const updateProductTranslationsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ProductSuccessMessageEnum.UPDATE_PRODUCT_DETAILS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.UPDATE_PRODUCT_DETAILS)
        };
};

export const updateProductEansNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ProductSuccessMessageEnum.UPDATE_PRODUCT_EANS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.UPDATE_PRODUCT_EANS)
        };
};

export const updateProductSalesDetailsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ProductSuccessMessageEnum.UPDATE_PRODUCT_SALES_DATA
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.UPDATE_PRODUCT_SALES_DATA)
        };
};

export const updateProductStatusNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ProductSuccessMessageEnum.UPDATE_PRODUCT_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.UPDATE_PRODUCT_STATUS)
        };
};

export const getQRCodeNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_LABEL)
    };
};

export const getLanguagesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_LANGUAGES)
    };
};

export const getConstantsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_CONSTANTS)
    };
};

export const getProducersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRODUCERS)
    };
};

export const getAllProducersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_ALL_PRODUCERS)
    };
};

export const getProducerNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRODUCER)
    };
};

export const createProducerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ProductSuccessMessageEnum.CREATE_PRODUCER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.CREATE_PRODUCER)
        };
};

export const updateProducerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ProductSuccessMessageEnum.UPDATE_PRODUCER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.UPDATE_PRODUCER)
        };
};

export const deleteProducerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ProductSuccessMessageEnum.DELETE_PRODUCER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.DELETE_PRODUCER)
        };
};

export const getAllHeatingProgramsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_ALL_HEATING_PROGRAMS)
    };
};

export const getPriceListProductsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRICE_LIST_PRODUCTS)
    };
};

export const getItemPriceListsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_ITEM_PRICE_LISTS)
    };
};

export const getProductsFromProductAvailabilityForDocumentNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getProductErrorMessage(response?.payload?.message, ProductErrorMessageEnum.GET_PRODUCTS_FROM_PRODUCT_AVAILABILITY_FOR_DOCUMENT)
    };
};

//---------------------------------------------------------------------------------------------------------------------- Benefit

export const getEmployersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.GET_EMPLOYERS)
    };
};

export const getAllEmployersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.GET_ALL_EMPLOYER)
    };
};

export const getEmployerNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.GET_EMPLOYER)
    };
};

export const getEmployerBillingScheduleNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.GET_EMPLOYER_BILLING_SCHEDULE)
    };
};

export const updateEmployerBillingScheduleNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: BenefitSuccessMessageEnum.UPDATE_EMPLOYER_BILLING_SCHEDULE
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.UPDATE_EMPLOYER_BILLING_SCHEDULE)
        };
};


export const getEmployerDiscountNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.GET_EMPLOYER_DISCOUNT)
    };
};

export const updateEmployerDiscountNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: BenefitSuccessMessageEnum.UPDATE_EMPLOYER_DISCOUNT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.UPDATE_EMPLOYER_DISCOUNT)
        };
};

export const deleteEmployerDiscountNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: BenefitSuccessMessageEnum.DELETE_EMPLOYER_DISCOUNT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.DELETE_EMPLOYER_DISCOUNT)
        };
};

export const getEmployerReportNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: BenefitSuccessMessageEnum.CREATE_REPORT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.CREATE_REPORT)
        };
};

export const updateEmployerNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: BenefitSuccessMessageEnum.UPDATE_EMPLOYER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.UPDATE_EMPLOYER)
        };
};

export const updateEmployerStatusNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: BenefitSuccessMessageEnum.UPDATE_EMPLOYER_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.UPDATE_EMPLOYER_STATUS)
        };
};

export const getEmployeesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.GET_EMPLOYEES)
    };
};

export const getEmployeesToConfirmNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.GET_EMPLOYEES_TO_CONFIRM)
    };
};

export const updateEmployeeNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: BenefitSuccessMessageEnum.UPDATE_EMPLOYEE
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getBenefitErrorMessage(response?.payload?.message, BenefitErrorMessageEnum.UPDATE_EMPLOYEE)
        };
};

//---------------------------------------------------------------------------------------------------------------------- Reservation

export const getPodReservationConfigsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.GET_POD_RESERVATION_CONFIGS)
    };
};

export const getProductsAvailabilityNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.GET_PRODUCTS_AVAILABILITY)
    };
};

export const getProductsAvailabilitySingleDayNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.GET_PRODUCTS_AVAILABILITY_SINGLE_DAY)
    };
};

export const createProductAvailabilityNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ReservationSuccessMessageEnum.CREATE_PRODUCT_AVAILABILITY
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.CREATE_PRODUCT_AVAILABILITY)
        };
};

export const importProductAvailabilityNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ReservationSuccessMessageEnum.IMPORT_PRODUCT_AVAILABILITY
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.IMPORT_PRODUCT_AVAILABILITY)
        };
};

export const deleteProductAvailabilityNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ReservationSuccessMessageEnum.DELETE_PRODUCT_AVAILABILITY
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.DELETE_PRODUCT_AVAILABILITY)
        };
};

export const updateProductQuantityLimitNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ReservationSuccessMessageEnum.UPDATE_PRODUCT_QUANTITY_LIMIT
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.UPDATE_PRODUCT_QUANTITY_LIMIT)
        };
};

export const getReservationsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.GET_RESERVATIONS)
    };
};

export const getCustomerReservationsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.GET_CUSTOMER_RESERVATIONS)
    };
};

export const deleteReservationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ReservationSuccessMessageEnum.DELETE_RESERVATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.DELETE_RESERVATION)
        };
};

export const returnReservationNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ReservationSuccessMessageEnum.RETURN_RESERVATION
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.RETURN_RESERVATION)
        };
};

export const updateReservationStoreStatusNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: ReservationSuccessMessageEnum.UPDATE_RESERVATION_STORE_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.UPDATE_RESERVATION_STORE_STATUS)
        };
};

export const generateArrangementNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getReservationErrorMessage(response?.payload?.message, ReservationErrorMessageEnum.GENERATE_ARRANGEMENT)
    };
};

//---------------------------------------------------------------------------------------------------------------------- Order

export const getCartEventsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.GET_CART_EVENTS)
    };
};

export const getTheftRegistriesNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.GET_THEFT_REGISTRIES)
    };
};

export const getTheftRegistriesForStoreNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.GET_THEFT_REGISTRIES_FOR_STORE)
    };
};

export const getTheftRegistryNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.GET_THEFT_REGISTRY)
    };
};

export const getPodOrdersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.GET_POD_ORDERS)
    };
};

export const getOrdersNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.GET_ORDERS)
    };
};

export const getSalesStatsNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.GET_SALES_STATS)
    };
};

export const getReservationOrderNotificationData = (response) => {
    return {
        status: response?.meta?.requestStatus,
        message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.GET_RESERVATION_ORDER)
    };
};

export const createTheftRegistryNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: OrderSuccessMessageEnum.CREATE_THEFT_REGISTRY
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.CREATE_THEFT_REGISTRY)
        };
};

export const updateTheftRegistryStatusNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: OrderSuccessMessageEnum.UPDATE_THEFT_REGISTRY_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.UPDATE_THEFT_REGISTRY_STATUS)
        };
};

export const cancelTheftRegistryNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: OrderSuccessMessageEnum.CANCEL_THEFT_REGISTRY
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.CANCEL_THEFT_REGISTRY)
        };
};

export const createTheftRegistrySmsNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: OrderSuccessMessageEnum.CREATE_THEFT_REGISTRY_SMS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.CREATE_THEFT_REGISTRY_SMS)
        };
};

export const returnOrderNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: OrderSuccessMessageEnum.RETURN_ORDER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.RETURN_ORDER)
        };
};

export const createPodOrderNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: OrderSuccessMessageEnum.CREATE_POD_ORDER
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.CREATE_POD_ORDER)
        };
};

export const updatePodOrderStatusNotificationData = (response) => {
    return response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED
        ? {
            status: ApiRequestStatusEnum.FULFILLED,
            message: OrderSuccessMessageEnum.UPDATE_POD_ORDER_STATUS
        }
        : {
            status: ApiRequestStatusEnum.REJECTED,
            message: getOrderErrorMessage(response?.payload?.message, OrderErrorMessageEnum.UPDATE_POD_ORDER_STATUS)
        };
};
